
export enum CampCareFormMode {
    AddNew = 0,
    Edit = 1,
    Generate = 2
}
